import { createStyles } from 'antd-style';

export const useStyles = createStyles(({ token, css, responsive }) => {
  return {
    container: css`
      height: 100vh;
      display: flex;
    `,
    container2: css`
      height: calc(100vh - 40px);
    `,
    contentWrap: css`
      display: flex;
      flex-direction: column;
      flex: auto;
      flex: 1;
      margin-left: unset;
      min-height: 0;
      padding-right: 26px;
      justify-content: center;
      ${responsive.mobile} {
        padding-right: 0px;
      }
    `,
    content: css`
      padding-top: 20px;
      padding-bottom: 20px;
      overflow-y: scroll;
      overflow-y: overlay;
      flex: auto;
      box-sizing: border-box;
    `,
    contentInfo: css`
      max-width: 1286px;
      width: 100%;
      margin: 0 auto;
      height: 100%;
      display: flex;
      flex-direction: column;
    `,
    title: css`
      font-size: 20px;
      font-weight: 400;
      margin-bottom: 24px;
    `,
    outlet: css`
      flex: 1;
      height: 0px;
    `,
    topHeader: css`
      height: 40px;
      background-color: ${token.colorPrimary};
      color: #fff;
      line-height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
      font-size: 14px;
      ${responsive.tablet} {
        font-size: 12px;
      }
    `
  };
});
